export const SUBMIT_CATEGORY_FORM = 'categoryForm/SUBMIT_CATEGORY_FORM';
